module.exports = __webpack_public_path__ + "img/feature-coach@2x.2492ff2c.jpg";